module.exports = __webpack_public_path__ + "static/media/bi_emblem_white.a8b71dc4.png";